<template>
  <div class="fyApplyIndex">
    <Header title="成绩复议" type="0" route="/homeIndex"></Header>
    <NOdata
      v-if="this.list && this.list.length == 0"
      title="未查询到成绩复议申请"
    ></NOdata>
    <div v-else class="content">
      <p>
        {{ tsxx }}
      </p>
      <div class="list">
        <div
          class="list-item update"
          v-for="(item, index) of list"
          :key="index"
        >
          <p>{{ item.kcmc }}[{{ item.kcbh }}]</p>
          <ul>
            <li>课程属性：{{ item.kcsx }}</li>
            <li>课程性质：{{ item.kcxzmc }}</li>
            <li>课程类别：{{ item.lbmc }}</li>
            <li>总学时：{{ item.zxs }}</li>
            <li>学分：{{ item.xf }}</li>
            <li>总成绩：{{ item.zcj }}</li>
            <li>考试性质：{{ item.ksxz }}</li>
            <li>考核方式：{{ item.ksfs }}</li>
            <!-- <li v-if="item.value != '报名'" :class="item.class">
              状态：{{ item.text }}}
            </li> -->
          </ul>
          <span
            v-if="item.cjfhsqid === '' || item.iswfmes === 3"
            class="bmClass"
            @click="showPopup(item)"
          >
            申请
          </span>
        </div>
      </div>
      <div class="bottom-btn">
        <span>
          <button @click="goResult()">复议申请结果</button>
        </span>
      </div>
    </div>
    <van-popup v-model="show2" closeable round>
      <div class="apply">
        <span class="title">申请</span>
        <van-field
          v-model="sqyy.mc"
          label="申请原因"
          right-icon="arrow"
          required
          input-align="right"
          placeholder="请点击选择"
          @click="onShow('申请原因', 'sqyy')"
          readonly
        />
        <p>
          ps:请认真输入成绩复议的原因，保存并送审后，视为成绩复议生效!
        </p>
        <van-field
          v-model="shr.mc"
          label="审核人"
          right-icon="arrow"
          input-align="right"
          placeholder="请点击选择"
          @click="show1 = true"
          readonly
        />
        <p>
          ps:不选则默认推送给所有审核人
        </p>
        <div class="bottom-btn">
          <span>
            <button @click="apply">申请</button>
          </span>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
        @cancel="show = false"
      />
    </van-popup>
    <van-popup v-model="show1" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="show1 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

import Vue from "vue";
import { Picker } from "vant";

Vue.use(Picker);
export default {
  data() {
    return {
      tsxx: "",
      sqyy: {},
      show: false,
      show2: false,
      valueList: {
        label: "",
        value: "",
        item: []
      },
      list: [],
      cjfhsqjl: [],
      columns: {},
      shr: {},
      show1: false,
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      params: {}
    };
  },
  methods: {
    async apply() {
      if (JSON.stringify(this.sqyy) === "{}") {
        this.$toast.fail("请选择申请原因");
        return;
      }
      this.params.userid = this.shr.dm;
      this.params.sqyy = this.sqyy.dm;
      const res = await Api.fycjsq(this.params);
      if (res.code === "1") {
        this.$toast.success("申请成功!");
        this.getList();
        this.show2 = false;
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      const params = {
        ywcode: "103",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    },
    goResult() {
      this.$router.push({
        path: "/fyApply/result"
      });
    },
    showPopup(item) {
      this.show2 = true;
      this.params.jx0404id = item.jx0404id;
      this.params.jx02id = item.jx02id;
      this.params.cj0703id = item.cj0703id;
      this.params.cj0704id = item.cj0704id;
      this.params.cj0708id = item.cj0708id;
      this.params.zcj = item.zcj;
      this.params.kkxq = item.xnxqid;
    },
    onShow(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    },
    async getList() {
      const res = await Api.cjfh_list();
      this.tsxx = res.data.tsxx;
      this.list = res.data.xscjList;
      this.columns.sqyy = res.data.sqyy.map(item => {
        return {
          text: item.dmmc,
          value: item.dm
        };
      });

      this.params.kzmcs = res.data.kzmcs;
      this.params.cjfhkzid = res.data.cjfhkzid;
      this.params.cjlrxq = res.data.cjlrxq;
      this.params.cjfhxq = res.data.cjfhxq;
      this.params.kzxnxq = res.data.kzxnxq;
    }
  },
  created() {
    this.getList();
    this.getShr();
  }
};
</script>
<style lang="less" scoped>
.fyApplyIndex {
  .content {
    padding: 0 5% 60px;
    p {
      color: red;
      margin-bottom: 10px;
      font-size: 12px;
    }
    .list {
      .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin: 0 auto 5%;
        padding: 3% 0 3% 6%;
        position: relative;
        p {
          height: 22px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          margin-bottom: 2%;
        }
        ul li {
          height: 17px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
      }

      .update span {
        height: 20px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        letter-spacing: 0;
        position: absolute;
        top: calc(50% - 10px);
        right: 5%;
        font-weight: bolder;
      }
      .shzClass {
        color: #7469f8 !important;
      }
      .btgClass {
        color: #5e4242 !important;
      }
      .ytgClass {
        color: #12ddd6 !important;
      }
      .dssClass {
        color: #757da3 !important;
      }
      .bmClass {
        width: 70px;
        height: 42px !important;
        top: calc(50% - 21px) !important;
        background: #7469f8;
        border-radius: 3px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
      }
      .qxbmClass {
        width: 70px;
        height: 42px !important;
        top: calc(50% - 21px) !important;
        background: #f7e3e3;
        border-radius: 3px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #f86969;
      }
    }
  }
  .bottom-btn {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding: 0 5% 10px 5%;
    background: #fff;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
    // span {
    //   display: inline-flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   button:first-child {
    //     width: 45%;
    //     height: 44px;
    //     background: #ecedfd;
    //     border-radius: 3px;
    //     color: #7469f8;
    //   }
    //   button:last-child {
    //     width: 45%;
    //     height: 44px;
    //     background: #7469f8;
    //     border-radius: 3px;
    //     color: #fff;
    //   }
    //   .single {
    //     width: 100% !important;
    //   }
    // }
  }
  .apply {
    position: relative;
    box-sizing: border-box;
    width: 80vw;
    height: 50vh;
    padding: 50px 0 20px;

    .title {
      color: #c8c9cc;
      position: absolute;
      left: 20px;
      top: 10px;
    }
    p {
      color: red;
      font-size: 12px;
      padding: 10px 16px;
    }
  }
  /* 审核人 */
  .close-icon {
    background: url(../../../../../static/img/close.png) no-repeat center;
  }
  .confirm-icon {
    background: url(../../../../../static/img/confirm.png) no-repeat center;
  }
  .pop-title i {
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    padding: 10px;
  }
  .pop-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .person {
    padding: 15px;
  }
  .person button {
    border-radius: 3px;
    padding: 5px 15px;
    margin-right: 12px;
    margin-bottom: 10px;
  }
  .apply-pop .person .per-btn {
    background-color: #ecedfd;
    color: #7469f8;
  }
  .person .cur {
    background-color: #7469f8;
    color: #ecedfd;
  }

  .icon {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/fyApply/index.vue